import React from "react";
import { useAuth } from "../../hooks/useAuth";
import { Box, Typography } from "@mui/material";

const AvatarImage = ({
  height,
  width,
  firstName,
  lastName,
}: {
  height: number;
  width: number;
  firstName: string;
  lastName: string;
}) => {
  // Get initials
  const getInitials = () => {
    const firstInitial = firstName ? firstName.charAt(0) : "";
    const lastInitial = lastName ? lastName.charAt(0) : "";
    return (firstInitial + lastInitial).toUpperCase();
  };
  // Generate a consistent color based on the user's name
  const getBackgroundColor = () => {
    const colors = ["#6881C8", "#3E3E3B7D", "#B8B8B8", "#BDBDBD", "#3E3873"];

    const nameHash = (firstName + lastName)
      .split("")
      .reduce((acc, char) => acc + char.charCodeAt(0), 0);

    return colors[nameHash % colors.length];
  };

  return (
    <Box
      sx={{
        backgroundColor: getBackgroundColor(),
        height: height,
        width: width,
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: 17,
          fontWeight: "bold",
          textTransform: "uppercase",
          lineHeight: 1,
          letterSpacing: 0.5,
          color: "white",
        }}
      >
        {getInitials()}
      </Typography>
    </Box>
  );
};

export default AvatarImage;
